const CONFIG = {
  API_BASE: {
    production: 'https://api.aplazo.mx/api',
    sandbox: 'https://api.aplazo.tech/api',
  },
};

module.exports = CONFIG;
